import type { ThemeAppearance } from '@atlaskit/lozenge';
import type { SearchResultMercuryFocusArea } from '@atlassian/search-client';

const getStatusApperanceFromKey = (key?: string): ThemeAppearance => {
	switch (key) {
		case 'off_track':
		case 'red':
			return 'removed';
		case 'at_risk':
		case 'yellow':
			return 'moved';
		case 'on_track':
		case 'green':
			return 'success';
		case 'completed':
		case 'paused':
		case 'pending':
		default:
			return 'default';
	}
};

export const getDisplayedFocusAreaStatus = (partial: SearchResultMercuryFocusArea) => {
	const { focusArea } = partial;

	const displayedStatus =
		focusArea?.status?.key === 'in_progress'
			? focusArea?.health?.displayName
			: focusArea?.status?.displayName;
	const displayedStatusAppearance = getStatusApperanceFromKey(
		focusArea?.health?.color.toLowerCase() || focusArea?.health?.key || focusArea?.status?.key,
	);

	return { displayedStatus, displayedStatusAppearance };
};
